/* im8x, shared behaviour. Idempotent: safe to load once, runs on DOM ready
   and again after Shopify section re-renders in the theme editor. */
(function () {
  'use strict';

  /* ---------------- accordions ---------------- */
  function initAccordions(root) {
    root.querySelectorAll('[data-im8x-acc]').forEach(function (acc) {
      if (acc.dataset.im8xReady) return;
      acc.dataset.im8xReady = '1';
      var single = acc.dataset.im8xAcc === 'single';

      acc.querySelectorAll('.im8x-acc__btn').forEach(function (btn) {
        var item = btn.closest('.im8x-acc__item');
        var panel = item.querySelector('.im8x-acc__panel');
        if (!panel) return;

        function setOpen(open) {
          item.dataset.open = open ? 'true' : 'false';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.style.height = open ? panel.scrollHeight + 'px' : '0px';
        }
        setOpen(item.dataset.open === 'true');

        btn.addEventListener('click', function () {
          var willOpen = item.dataset.open !== 'true';
          if (single && willOpen) {
            acc.querySelectorAll('.im8x-acc__item').forEach(function (other) {
              if (other === item) return;
              other.dataset.open = 'false';
              var ob = other.querySelector('.im8x-acc__btn');
              var op = other.querySelector('.im8x-acc__panel');
              if (ob) ob.setAttribute('aria-expanded', 'false');
              if (op) op.style.height = '0px';
            });
          }
          setOpen(willOpen);
        });

        window.addEventListener('resize', function () {
          if (item.dataset.open === 'true') panel.style.height = panel.scrollHeight + 'px';
        });
      });
    });
  }

  /* ---------------- reveal: meters + count-ups ---------------- */
  function initReveal(root) {
    var targets = root.querySelectorAll('[data-im8x-meter],[data-im8x-count]');
    if (!targets.length) return;

    function run(el) {
      if (el.dataset.im8xDone) return;
      el.dataset.im8xDone = '1';

      if (el.hasAttribute('data-im8x-meter')) {
        var bar = el.querySelector('span');
        if (bar) bar.style.width = (el.dataset.im8xMeter || '0') + '%';
      }
      if (el.hasAttribute('data-im8x-count')) {
        var end = parseFloat(el.dataset.im8xCount) || 0;
        var suffix = el.dataset.im8xSuffix || '';
        var prefix = el.dataset.im8xPrefix || '';
        var dp = parseInt(el.dataset.im8xDecimals || '0', 10);
        var dur = 900, t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + (end * eased).toFixed(dp) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          el.textContent = prefix + end.toFixed(dp) + suffix;
        } else {
          requestAnimationFrame(step);
        }
      }
    }

    if (!('IntersectionObserver' in window)) {
      targets.forEach(run);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    targets.forEach(function (el) { if (!el.dataset.im8xDone) io.observe(el); });
  }

  /* ---------------- tabs ---------------- */
  function initTabs(root) {
    root.querySelectorAll('[data-im8x-tabs]').forEach(function (wrap) {
      if (wrap.dataset.im8xReady) return;
      wrap.dataset.im8xReady = '1';
      var tabs = wrap.querySelectorAll('[data-im8x-tab]');
      var panels = wrap.querySelectorAll('[data-im8x-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.dataset.im8xTab;
          tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
          panels.forEach(function (p) { p.hidden = p.dataset.im8xPanel !== key; });
        });
      });
    });
  }

  /* ---------------- dispatch panel ----------------

     Everything is worked out against Europe/London rather than the visitor's
     own clock, so a device set to the wrong timezone still shows the real
     cutoff. British Summer Time is handled for free because Intl does the
     conversion, rather than us hardcoding an offset that breaks twice a year.

     Bank holidays are deliberately not handled — a handful of wrong days a
     year was judged an acceptable trade against maintaining a date list. */
  var LONDON = 'Europe/London';
  var DAY_NAMES = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONTH_NAMES = ['January','February','March','April','May','June',
                     'July','August','September','October','November','December'];

  function londonNow() {
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: LONDON, hour12: false,
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric', weekday: 'long'
      }).formatToParts(new Date());
    } catch (e) {
      /* No Intl timezone support: fall back to the device clock rather than
         showing nothing at all. */
      var d = new Date();
      return {
        year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(),
        hour: d.getHours(), minute: d.getMinutes(), second: d.getSeconds(),
        dow: d.getDay()
      };
    }

    var out = {};
    parts.forEach(function (p) {
      if (p.type === 'weekday') out.weekday = p.value;
      else if (p.type !== 'literal') out[p.type] = parseInt(p.value, 10);
    });
    /* Intl reports hour 24 at midnight in some engines. */
    if (out.hour === 24) out.hour = 0;
    out.dow = DAY_NAMES.indexOf(out.weekday);
    return out;
  }

  function initDispatch(root) {
    (root || document).querySelectorAll('[data-im8x-dispatch]').forEach(function (panel) {
      if (panel.dataset.im8xReady) return;
      panel.dataset.im8xReady = '1';

      var mainEl = panel.querySelector('[data-dispatch-main]');
      var subEl = panel.querySelector('[data-dispatch-sub]');
      if (!mainEl || !subEl) return;

      var cutoffHour = parseInt(panel.getAttribute('data-cutoff-hour'), 10);
      var timerFrom = parseInt(panel.getAttribute('data-timer-from'), 10);
      if (isNaN(cutoffHour)) cutoffHour = 15;
      if (isNaN(timerFrom)) timerFrom = 9;

      var labelToday = panel.getAttribute('data-label-today') || 'Ships today';
      var labelTomorrow = panel.getAttribute('data-label-tomorrow') || 'Ships tomorrow';
      var labelLater = panel.getAttribute('data-label-later') || 'Ships';
      var wordBefore = panel.getAttribute('data-before') || 'if you order before';
      var wordWithin = panel.getAttribute('data-within') || 'if you order within';

      function isWeekend(dow) { return dow === 0 || dow === 6; }

      function clockLabel(hour) {
        if (hour === 12) return 'midday';
        var suffix = hour < 12 ? 'am' : 'pm';
        var h = hour % 12;
        if (h === 0) h = 12;
        return h + suffix;
      }

      function countdown(seconds) {
        var h = Math.floor(seconds / 3600);
        var m = Math.floor((seconds % 3600) / 60);
        var s = seconds % 60;
        var pad = function (n) { return n < 10 ? '0' + n : String(n); };
        if (h > 0) return h + 'hr ' + m + 'mins ' + pad(s) + 'sec';
        if (m > 0) return m + 'mins ' + pad(s) + 'sec';
        return s + 'sec';
      }

      function render() {
        var now = londonNow();
        var secondsNow = now.hour * 3600 + now.minute * 60 + now.second;
        var secondsToCutoff = cutoffHour * 3600 - secondsNow;

        var shipsToday = !isWeekend(now.dow) && secondsToCutoff > 0;

        /* Work out the shipping date by stepping forward from today in UTC —
           safe because we only ever read it back with the UTC getters. */
        var shipDate = new Date(Date.UTC(now.year, now.month - 1, now.day));
        var daysAhead = 0;
        if (!shipsToday) {
          daysAhead = 1;
          var probe = new Date(shipDate.getTime());
          probe.setUTCDate(probe.getUTCDate() + 1);
          while (probe.getUTCDay() === 0 || probe.getUTCDay() === 6) {
            probe.setUTCDate(probe.getUTCDate() + 1);
            daysAhead++;
          }
          shipDate = probe;
        }

        var dateText = DAY_NAMES[shipDate.getUTCDay()] + ' ' +
                       shipDate.getUTCDate() + ' ' +
                       MONTH_NAMES[shipDate.getUTCMonth()];

        var lead;
        if (shipsToday) lead = labelToday;
        else if (daysAhead === 1) lead = labelTomorrow;
        else lead = labelLater;

        mainEl.textContent = lead + ', ' + dateText;

        if (shipsToday && now.hour >= timerFrom) {
          subEl.textContent = wordWithin + ' ' + countdown(secondsToCutoff);
        } else if (shipsToday) {
          subEl.textContent = wordBefore + ' ' + clockLabel(cutoffHour);
        } else {
          subEl.textContent = '';
        }

        panel.setAttribute('data-ready', 'true');
      }

      render();
      setInterval(render, 1000);
    });
  }

  /* ---------------- thumbnail strip scroll fades ---------------- */
  function initStripFades(root) {
    (root || document).querySelectorAll('[data-im8x-strip]').forEach(function (wrap) {
      if (wrap.dataset.im8xFadeReady) return;
      wrap.dataset.im8xFadeReady = '1';

      var strip = wrap.querySelector('[data-im8x-expand-grid]');
      if (!strip) return;

      function update() {
        var max = strip.scrollWidth - strip.clientWidth;
        var scrollable = max > 1;
        var x = strip.scrollLeft;
        wrap.dataset.moreLeft = (scrollable && x > 1) ? 'true' : 'false';
        wrap.dataset.moreRight = (scrollable && x < max - 1) ? 'true' : 'false';
      }

      strip.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      setTimeout(update, 400);
      update();
    });
  }

  /* ---------------- pack size toggle ----------------
     Note the getAttribute calls. These attributes end in a digit
     (data-price-1, data-variant-2), and the dataset API only strips a dash
     when a LETTER follows it — so dataset.price1 is undefined and the values
     have to be read by their full attribute name. */
  function initPacks(root) {
    root.querySelectorAll('[data-im8x-packs]').forEach(function (wrap) {
      if (wrap.dataset.im8xReady) return;
      wrap.dataset.im8xReady = '1';

      var form = document.querySelector('[data-im8x-form]');
      var idInput = form && form.querySelector('[name="id"]');
      var buttons = wrap.querySelectorAll('[data-im8x-pack]');

      function apply(pack) {
        wrap.dataset.pack = pack;

        buttons.forEach(function (b) {
          var on = b.getAttribute('data-im8x-pack') === pack;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', String(on));
        });

        var variant = wrap.getAttribute('data-variant-' + pack);
        if (idInput && variant) idInput.value = variant;

        document.querySelectorAll('[data-im8x-plan]').forEach(function (card) {
          var price = card.getAttribute('data-price-' + pack) || card.getAttribute('data-price-1');
          var unit = card.getAttribute('data-unit-' + pack) || card.getAttribute('data-unit-1');
          var billed = card.getAttribute('data-billed-' + pack) || card.getAttribute('data-billed-1');
          /* The was price is the exception: no fallback. Showing the 1-pack was
             price next to a 2-pack price would be a wrong comparison. */
          var was = card.getAttribute('data-was-' + pack) || '';

          var priceEl = card.querySelector('.im8x-plan__price');
          var unitEl = card.querySelector('.im8x-plan__unit');
          var billedEl = card.querySelector('.im8x-plan__billed');
          var wasEl = card.querySelector('.im8x-plan__was');
          if (priceEl && price) priceEl.textContent = price;
          if (unitEl && unit) unitEl.textContent = unit;
          if (billedEl && billed) billedEl.textContent = billed;
          if (wasEl) wasEl.textContent = was;

          card.dataset.planPrice = price || '';
          card.dataset.planUnit = unit || '';

          if (card.dataset.selected === 'true') {
            document.dispatchEvent(new CustomEvent('im8x:plan', {
              detail: {
                label: card.dataset.planLabel || '',
                price: price || '',
                unit: unit || ''
              }
            }));
          }
        });
      }

      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          apply(b.getAttribute('data-im8x-pack'));
        });
      });

      apply(wrap.dataset.pack || '1');
    });
  }

  /* ---------------- plan selector ---------------- */
  function initPlans(root) {
    root.querySelectorAll('[data-im8x-plans]').forEach(function (wrap) {
      if (wrap.dataset.im8xReady) return;
      wrap.dataset.im8xReady = '1';
      var form = wrap.closest('form') || document.querySelector('[data-im8x-form]');

      function apply(card) {
        wrap.querySelectorAll('[data-im8x-plan]').forEach(function (c) {
          c.dataset.selected = String(c === card);
          c.setAttribute('aria-checked', String(c === card));
          c.setAttribute('tabindex', c === card ? '0' : '-1');
          var input = c.querySelector('input[type="radio"]');
          if (input) input.checked = (c === card);
        });
        var planInput = form && form.querySelector('[name="selling_plan"]');
        if (planInput) planInput.value = card.dataset.planId || '';

        /* Deliberately not touching the id input here: the pack toggle owns the
           variant. Setting it from the plan too would let the two fight. */

        document.dispatchEvent(new CustomEvent('im8x:plan', {
          detail: {
            label: card.dataset.planLabel || '',
            price: card.dataset.planPrice || '',
            unit: card.dataset.planUnit || ''
          }
        }));
      }

      wrap.querySelectorAll('[data-im8x-plan]').forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('a,button:not([data-im8x-plan])')) return;
          apply(card);
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); apply(card); }
        });
      });

      var initial = wrap.querySelector('[data-im8x-plan][data-selected="true"]') ||
                    wrap.querySelector('[data-im8x-plan]');
      if (initial) apply(initial);
    });
  }

  /* ---------------- add to cart ----------------

     The theme is Dawn-based, and Dawn intercepts add-to-cart through its own
     <product-form> custom element. Our form is plain markup, so without this
     the browser does an ordinary POST and navigates away to the cart page,
     abandoning the landing page and any upsell that would have run there.

     So we submit it ourselves, then re-render the cart drawer using the same
     sections call the theme already uses elsewhere.

     Every failure path falls back to a normal form submit. A customer who
     cannot add to cart is a far worse outcome than one who lands on the cart
     page, so nothing here is allowed to swallow an error silently. */
  function findDrawer() {
    return document.querySelector('cart-drawer');
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  /* Re-render the drawer and the header count from the server, then open it.
     Mirrors the routine already in theme.liquid so both behave identically. */
  function refreshAndOpenDrawer() {
    return fetch(cartUrl() + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();

        if (sections['cart-drawer']) {
          var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('cart-drawer');
          var current = findDrawer();
          if (fresh && current) current.replaceWith(fresh);
        }

        if (sections['cart-icon-bubble']) {
          var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var freshBubble = bubbleDoc.querySelector('#cart-icon-bubble');
          var currentBubble = document.querySelector('#cart-icon-bubble');
          if (freshBubble && currentBubble) currentBubble.replaceWith(freshBubble);
        }

        var drawer = findDrawer();
        if (!drawer) return false;

        drawer.classList.remove('is-empty');
        drawer.classList.add('active');
        if (typeof drawer.open === 'function') drawer.open();
        document.body.classList.add('overflow-hidden');
        return true;
      });
  }

  /* Apps that listen for cart changes hook different events depending on how
     they were built, so tell everyone. Dawn's own pubsub is used when present;
     the DOM events cover apps that listen on document instead. */
  function announceCartUpdate() {
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'im8x-product-form' });
      }
    } catch (e) { /* pubsub absent or shaped differently; the DOM events still fire */ }

    ['cart:updated', 'cart:refresh', 'cart:build'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'im8x' } }));
    });
  }

  function initCartForm(root) {
    (root || document).querySelectorAll('[data-im8x-form] form').forEach(function (form) {
      if (form.dataset.im8xCartReady) return;
      form.dataset.im8xCartReady = '1';

      form.addEventListener('submit', function (e) {
        /* No drawer on this theme means the cart page is the correct
           destination, so leave the normal submit alone. */
        if (!findDrawer()) return;

        e.preventDefault();

        var btn = form.querySelector('[type="submit"]');
        if (btn && btn.getAttribute('aria-busy') === 'true') return;
        if (btn) {
          btn.setAttribute('aria-busy', 'true');
          btn.classList.add('loading');
        }

                var picked = document.querySelector('[data-im8x-plan][data-selected="true"]');
        var planField = form.querySelector('[name="selling_plan"]');
        if (picked && planField) planField.value = picked.getAttribute('data-plan-id') || '';
        var data = new FormData(form);
        /* An empty selling_plan is rejected by the cart API, where the plain
           form POST simply ignored it. */
        if (!data.get('selling_plan')) data.delete('selling_plan');

        function release() {
          if (btn) {
            btn.removeAttribute('aria-busy');
            btn.classList.remove('loading');
          }
        }

        fetch(addUrl(), {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
            return res.json();
          })
          .then(function () {
            announceCartUpdate();
            return refreshAndOpenDrawer();
          })
          .then(function (opened) {
            release();
            /* The drawer vanished between the check and the render — send them
               to the cart rather than leaving them with no feedback. */
            if (!opened) window.location.href = cartUrl();
          })
          .catch(function (err) {
            console.error('[im8x]', err);
            release();
            /* Fall back to the ordinary submit so the customer still gets
               their item in the cart. */
            form.submit();
          });
      });
    });
  }

  /* ---------------- sticky add-to-cart bar ----------------

     The trigger is the real Add to cart button, not the end of the product
     block. The block keeps growing as sections are added to the column, and
     anchoring to its bottom meant the bar appeared far too late. Tying it to
     the button means the bar takes over at the moment the button leaves the
     screen, and it self-corrects however much the page changes. */
  function initSticky(root) {
    var bar = root.querySelector('[data-im8x-sticky]');
    if (!bar || bar.dataset.im8xReady) return;
    bar.dataset.im8xReady = '1';

    var sentinel = document.querySelector('[data-im8x-form] [type="submit"]') ||
                   document.querySelector('.im8x-main__atc') ||
                   document.querySelector('[data-im8x-sticky-after]');

    function toggle() {
      var show = sentinel
        ? sentinel.getBoundingClientRect().bottom < 0
        : window.scrollY > 600;
      bar.dataset.visible = show ? 'true' : 'false';
    }
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle);

    document.addEventListener('im8x:plan', function (e) {
      var label = bar.querySelector('[data-im8x-sticky-label]');
      var price = bar.querySelector('[data-im8x-sticky-price]');
      var unit = bar.querySelector('[data-im8x-sticky-unit]');
      if (label && e.detail.label) label.textContent = e.detail.label;
      if (price && e.detail.price) price.textContent = e.detail.price;
      if (unit && e.detail.unit) unit.textContent = e.detail.unit;
    });

    var cta = bar.querySelector('[data-im8x-sticky-cta]');
    if (cta) {
      cta.addEventListener('click', function (ev) {
        ev.preventDefault();
        submitProductForm();
      });
    }
  }

  /* Single place that knows how to add to cart. The main product form already
     holds the selected variant and selling plan, so any button anywhere on the
     page just submits that — and the handler above turns that submit into a
     drawer open. */
  function submitProductForm() {
    var wrap = document.querySelector('[data-im8x-form]');
    if (!wrap) return;
    var submit = wrap.querySelector('[type="submit"]');
    if (submit) { submit.click(); return; }
    var form = wrap.querySelector('form') || (wrap.tagName === 'FORM' ? wrap : null);
    if (form) form.submit();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-im8x-atc]') : null;
    if (!btn) return;
    e.preventDefault();
    submitProductForm();
  });

  function boot(root) {
    root = root || document;
    initAccordions(root);
    initReveal(root);
    initTabs(root);
    initCartForm(root);
    initSticky(root);
    initStripFades(root);
    initDispatch(root);
    /* packs before plans: the plan selector reads the price the pack toggle
       has just written. */
    initPacks(root);
    initPlans(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();

/* Product benefits selector: click a tile, show its panel, hide the rest. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-im8x-benefits]').forEach(function (root) {
    var tiles = root.querySelectorAll('[data-im8x-benefit-tile]');
    var panels = root.querySelectorAll('[data-im8x-benefit-panel]');

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        var targetId = tile.getAttribute('data-target');
        tiles.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tile.classList.add('is-active');
        tile.setAttribute('aria-selected', 'true');
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.id === targetId);
        });
      });
    });
  });
});

/* Tabbed reviews: click a category tab, show its panel, hide the rest. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-im8x-review-tabs]').forEach(function (tabBar) {
    var section = tabBar.closest('.im8x-scope');
    var tabs = tabBar.querySelectorAll('[data-im8x-review-tab]');
    var panels = section.querySelectorAll('[data-im8x-review-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('data-target');
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.id === targetId);
        });
      });
    });
  });
});

/* TikTok carousel: one video visible at a time, arrows + dots to navigate. */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-im8x-tt-viewer]').forEach(function (viewer) {
    var section = viewer.closest('.im8x-scope');
    var slides = viewer.querySelectorAll('[data-im8x-tt-slide]');
    var dots = section.querySelectorAll('[data-im8x-tt-dots] [data-index]');
    var prevBtn = section.querySelector('[data-im8x-tt-prev]');
    var nextBtn = section.querySelector('[data-im8x-tt-next]');
    var current = 0;

    function show(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      slides.forEach(function (s, i) {
        var wasActive = s.classList.contains('is-active');
        s.classList.toggle('is-active', i === current);
        var vid = s.querySelector('video');
        if (vid && wasActive && i !== current) vid.pause();
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-index'), 10));
      });
    });
  });
});

/* Gallery.

   Two behaviours share one piece of markup.

   Desktop (>=990px): the first image is the hero and the tiles below it are a
   two-column grid with exactly one tile expanded across both columns. The tile
   that duplicates the hero is hidden by CSS, so the grid holds the rest.
   Clicking a different tile moves the expansion; clicking the open one does
   nothing, so the column never collapses and nothing below it moves. The
   reflow can't be animated directly, so this uses FLIP: measure, change the
   layout, measure again, transform each tile back, then release.

   Phones (<990px): the hero is a horizontal track holding every image, moved
   by transform, and the strip below lists every image in a fixed order. The
   current one is ringed rather than removed, so a given position in the strip
   always opens the same picture. The track can be swiped, and the strip
   centres the selected tile. */
(function () {
  'use strict';

  var DURATION = 520;
  var EASING = 'cubic-bezier(.45,0,.25,1)';
  var VIEWPORT_SLACK = 120;
  /* Widely used carousel defaults: complete the swipe past a fifth of the
     width, or on a fast flick regardless of distance. */
  var SWIPE_RATIO = 0.2;
  var FLICK_VELOCITY = 0.3;
  /* Pixels of movement before deciding whether the gesture is a horizontal
     swipe or a vertical page scroll. */
  var AXIS_LOCK = 8;

  function initGallery(root) {
    (root || document).querySelectorAll('[data-im8x-expand-grid]').forEach(function (grid) {
      if (grid.dataset.im8xGalleryReady) return;
      grid.dataset.im8xGalleryReady = '1';

      var media = grid.closest('.im8x-main__media');
      if (!media) return;
      var track = media.querySelector('[data-im8x-track]');
      var isDesktop = window.matchMedia('(min-width: 990px)');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      var allTiles = Array.prototype.slice.call(grid.querySelectorAll('[data-im8x-expand-tile]'));
      var gridTiles = allTiles.filter(function (t) {
        return !t.classList.contains('im8x-main__moreTile--first');
      });

      /* ---------- phones: swipeable track ---------- */
      var index = 0;

      function offsetFor(i) { return -i * 100; }

      function paint(animate) {
        if (!track) return;
        track.classList.toggle('is-dragging', !animate);
        track.style.transform = 'translate3d(' + offsetFor(index) + '%,0,0)';
        allTiles.forEach(function (t, i) {
          t.classList.toggle('is-selected', i === index);
          t.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        centreTile();
      }

      /* Centre the selected tile. The clamp is what makes the two ends behave:
         images near the start or finish cannot be centred, so the strip rests
         at its limit and the ring sits off-centre there. */
      function centreTile() {
        var tile = allTiles[index];
        if (!tile || isDesktop.matches) return;
        var target = tile.offsetLeft - (grid.clientWidth - tile.offsetWidth) / 2;
        var max = grid.scrollWidth - grid.clientWidth;
        grid.scrollLeft = Math.max(0, Math.min(target, max));
      }

      function setIndex(i, animate) {
        var max = allTiles.length - 1;
        /* No wrapping: the ends are the ends. */
        index = Math.min(Math.max(i, 0), max);
        paint(animate !== false && !reduceMotion.matches);
      }

      if (track) {
        var startX = 0, startY = 0, startTime = 0;
        var dragging = false, axis = null, width = 0;

        track.addEventListener('touchstart', function (e) {
          if (isDesktop.matches || e.touches.length !== 1) return;
          var t = e.touches[0];
          startX = t.clientX;
          startY = t.clientY;
          startTime = Date.now();
          width = track.getBoundingClientRect().width || 1;
          dragging = true;
          axis = null;
        }, { passive: true });

        track.addEventListener('touchmove', function (e) {
          if (!dragging || isDesktop.matches) return;
          var t = e.touches[0];
          var dx = t.clientX - startX;
          var dy = t.clientY - startY;

          if (axis === null) {
            if (Math.abs(dx) < AXIS_LOCK && Math.abs(dy) < AXIS_LOCK) return;
            /* Mostly horizontal: take the gesture. Mostly vertical: let go and
               let the page scroll normally. */
            axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
            if (axis === 'y') { dragging = false; return; }
          }

          e.preventDefault();
          var resist = dx;
          /* Rubber-band at the two ends so the track feels bounded. */
          if ((index === 0 && dx > 0) || (index === allTiles.length - 1 && dx < 0)) {
            resist = dx * 0.35;
          }
          track.classList.add('is-dragging');
          track.style.transform = 'translate3d(calc(' + offsetFor(index) + '% + ' + resist + 'px),0,0)';
        }, { passive: false });

        function endDrag(e) {
          if (!dragging || axis !== 'x') { dragging = false; axis = null; return; }
          dragging = false;
          var touch = e.changedTouches && e.changedTouches[0];
          var dx = touch ? touch.clientX - startX : 0;
          var elapsed = Math.max(Date.now() - startTime, 1);
          var velocity = Math.abs(dx) / elapsed;
          var far = Math.abs(dx) > width * SWIPE_RATIO;
          var flick = velocity > FLICK_VELOCITY;

          if ((far || flick) && dx < 0) setIndex(index + 1);
          else if ((far || flick) && dx > 0) setIndex(index - 1);
          else setIndex(index);
          axis = null;
        }

        track.addEventListener('touchend', endDrag, { passive: true });
        track.addEventListener('touchcancel', endDrag, { passive: true });
      }

      /* ---------- desktop: expanding grid ---------- */
      function setOrders(expandedIndex) {
        gridTiles.forEach(function (t, i) { t.style.order = String(2 * i); });
        if (expandedIndex > 0 && expandedIndex % 2 === 1) {
          gridTiles[expandedIndex].style.order = String(2 * expandedIndex - 3);
        }
      }

      function clearAnimation() {
        grid.style.transition = '';
        grid.style.height = '';
        gridTiles.forEach(function (t) {
          t.style.transition = '';
          t.style.transform = '';
          t.style.transformOrigin = '';
        });
      }

      function onScreen(rect, viewportHeight) {
        return rect.bottom > -VIEWPORT_SLACK &&
               rect.top < viewportHeight + VIEWPORT_SLACK;
      }

      var animating = false;

      function relayout(mutate) {
        if (reduceMotion.matches) { mutate(); return; }

        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var first = gridTiles.map(function (t) { return t.getBoundingClientRect(); });
        var startH = grid.getBoundingClientRect().height;

        mutate();

        var last = gridTiles.map(function (t) { return t.getBoundingClientRect(); });
        var endH = grid.getBoundingClientRect().height;

        var moving = [];
        gridTiles.forEach(function (t, i) {
          if (!onScreen(first[i], viewportHeight) && !onScreen(last[i], viewportHeight)) return;
          var dx = first[i].left - last[i].left;
          var dy = first[i].top - last[i].top;
          var scale = last[i].width ? first[i].width / last[i].width : 1;
          t.style.transition = 'none';
          t.style.transformOrigin = 'top left';
          t.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')';
          moving.push(t);
        });

        grid.style.transition = 'none';
        grid.style.height = startH + 'px';
        grid.getBoundingClientRect();
        animating = true;

        requestAnimationFrame(function () {
          grid.style.transition = 'height ' + DURATION + 'ms ' + EASING;
          grid.style.height = endH + 'px';
          moving.forEach(function (t) {
            t.style.transition = 'transform ' + DURATION + 'ms ' + EASING;
            t.style.transform = '';
          });
          setTimeout(function () { clearAnimation(); animating = false; }, DURATION + 40);
        });
      }

      function ensureOneExpanded() {
        if (!isDesktop.matches || !gridTiles.length) return;
        var openIndex = -1;
        gridTiles.forEach(function (t, i) {
          if (t.classList.contains('is-expanded')) openIndex = i;
        });
        if (openIndex === -1) {
          gridTiles[0].classList.add('is-expanded');
          setOrders(0);
        }
      }

      /* ---------- one click handler, two behaviours ---------- */
      allTiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          if (!isDesktop.matches) {
            setIndex(parseInt(tile.getAttribute('data-index'), 10) || 0);
            return;
          }
          if (animating) return;
          if (tile.classList.contains('is-expanded')) return;
          var gi = gridTiles.indexOf(tile);
          if (gi === -1) return;
          relayout(function () {
            gridTiles.forEach(function (t) { t.classList.remove('is-expanded'); });
            tile.classList.add('is-expanded');
            setOrders(gi);
          });
        });
      });

      function onBreakpointChange() {
        gridTiles.forEach(function (t) { t.classList.remove('is-expanded'); });
        setOrders(-1);
        clearAnimation();
        animating = false;
        if (isDesktop.matches) {
          if (track) track.style.transform = '';
          ensureOneExpanded();
        } else {
          setIndex(index, false);
        }
      }
      if (isDesktop.addEventListener) isDesktop.addEventListener('change', onBreakpointChange);
      else if (isDesktop.addListener) isDesktop.addListener(onBreakpointChange);

      setOrders(-1);
      if (isDesktop.matches) ensureOneExpanded();
      else setIndex(0, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initGallery(document); });
  } else {
    initGallery(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initGallery(e.target); });
})();

/* Stat count-up. Reads the number straight out of the element's own text, so
   the editor keeps a single free-text field per stat. Animates only the digits
   and leaves any prefix or suffix alone. Runs once, on scroll into view. */
(function () {
  'use strict';

  function initCountUp(root) {
    var els = (root || document).querySelectorAll('[data-im8x-countup]');
    if (!els.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function run(el) {
      if (el.dataset.im8xCounted) return;

      var raw = el.textContent.trim();
      var match = raw.match(/-?\d+(?:[.,]\d+)?/);
      if (!match) return;
      el.dataset.im8xCounted = '1';
      if (reduceMotion) return;

      var numStr = match[0];
      var prefix = raw.slice(0, match.index);
      var suffix = raw.slice(match.index + numStr.length);
      var decimals = (numStr.split(/[.,]/)[1] || '').length;
      var end = parseFloat(numStr.replace(',', '.'));
      /* Squared easing rather than cubic: cubic dumps most of the movement in
         the first few hundred ms and then crawls. */
      var duration = 2200, start = null;

      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 2);
        if (p < 1) {
          el.textContent = prefix + (end * eased).toFixed(decimals) + suffix;
          requestAnimationFrame(step);
        } else {
          el.textContent = raw;
        }
      }

      el.textContent = prefix + (0).toFixed(decimals) + suffix;
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(run);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { if (!el.dataset.im8xCounted) io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCountUp(document); });
  } else {
    initCountUp(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initCountUp(e.target); });
})();
